export default "__VITE_ASSET__CEqqDRca__"